var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: "klienticta client-action-button",
    "class": _vm.classCst,
    attrs: {
      "type": "button",
      "aria-label": "Otvoriť chat s klientom",
      "title": "Otvoriť chat"
    },
    on: {
      "click": _vm.openClientChatPopUp
    }
  }, [_c('span', {
    staticClass: "client-action-icon"
  }, [_c('app-icon', {
    attrs: {
      "name": "chat",
      "size": 22
    }
  })], 1), _c('span', [_vm._v("Chat")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }